import React, { memo, useCallback } from 'react'
import tw from 'twin.macro'
import { CancelSmallMinor } from '@shopify/polaris-icons'
import { Typography, Tooltip } from '@mui/material'
import { cutLongWord } from 'src/utils/baseUtils'
import { Market } from 'src/interfaces/market'

interface Props {
  market: Market
  onRemove?: (market: Market) => void
}

const RemovableMarketComponent = ({ market, onRemove }: Props) => {
  const handleRemove = useCallback(() => {
    if (onRemove) {
      onRemove(market)
    }
  }, [market, onRemove])

  const shouldShowTooltip = market.title.length > 20

  return (
    <div css={tw`bg-[#EDEDED] rounded flex items-center py-1 px-2`}>
      {shouldShowTooltip ? (
        <Tooltip title={market.title} arrow>
          <Typography variant="subtitle1" css={tw`mx-1 my-0`}>
            {cutLongWord(market.title)}
          </Typography>
        </Tooltip>
      ) : (
        <Typography variant="subtitle1" css={tw`mx-1 my-0`}>
          {cutLongWord(market.title)}
        </Typography>
      )}

      {onRemove && (
        <div css={tw`h-5 ml-2 cursor-pointer hover:opacity-50`} onClick={handleRemove}>
          <CancelSmallMinor width={20} />
        </div>
      )}
    </div>
  )
}

export const RemovableMarket = memo(RemovableMarketComponent)
